module.exports = __webpack_public_path__ + "img/freestyle_box09.58c6ca34.jpg";